export const basePrivileges = [
  { name: "查看", value: "R" },
  { name: "新建", value: "C" },
  { name: "编辑", value: "U" },
  { name: "删除", value: "D" },
  { name: "导出", value: "E" },
  { name: "打印", value: "P" },
  { name: "更换负责人", value: "TL" },
  { name: "编辑团队成员", value: "TM" },
  { name: "复制", value: "CP" },
  { name: "锁定解锁", value: "LK" },
  { name: "关联项目", value: "RP" },
  { name: "同步", value: "SYNC"}
]

export const levelOptions = [
  { name: "全部", value: "ALL" },
  { name: "负责的", value: "CHARGE" },
  { name: "参与的", value: "PART" },
  // { name: "创建的", value: "MINE" },
  { name: "本人及下属负责的", value: "SUB_CHARGE" },
  { name: "本人及下属参与的", value: "SUB_PART" }
]

// 需要保持一致的权限
export const equalPrivileges = [["R", "E", "P"]]

// 不要比较值的比较方法
export const noValCompareMethod = [
  "为空",
  "不为空",
  "真",
  "假",
  "撤回",
  "是本人",
  "不是本人",
  "是本部门",
  "属于本部门",
  "含本部门",
  "是上级",
  "是下属",
  "本人及下属"
]

// 时间可以筛选的范围
export const timeRange = [
  { label: "今天", value: "0_day" },
  { label: "昨天", value: "-1_day" },
  { label: "明天", value: "1_day" },
  { label: "本周", value: "0_week" },
  { label: "上周", value: "-1_week" },
  { label: "下周", value: "1_week" },
  { label: "本月", value: "0_month" },
  { label: "上月", value: "-1_month" },
  { label: "下月", value: "1_month" },
  { label: "本季度", value: "0_season" },
  { label: "上季度", value: "-1_season" },
  { label: "下季度", value: "1_season" },
  { label: "本年度", value: "0_year" },
  { label: "上年度", value: "-1_year" },
  { label: "下年度", value: "1_year" }
]

export const defaultLogo =
  "https://new-service.oss-cn-hangzhou.aliyuncs.com/company-logo/defaultLogo.png"
